require('es6-promise').polyfill();
require('isomorphic-fetch');

function compare(sort, sortDirection) {
    return function compare(a, b) {
        if (!isNaN(parseFloat(a[sort]))) {
            let valA = parseFloat(a[sort] || 0.0);
            let valB = parseFloat(b[sort] || 0.0);
            if (sortDirection === Sort.direction.ascending) {
                return valA - valB;
            } else {
                return valB - valA;
            }
        } else if (!isNaN(parseFloat(b[sort]))) {
            let valA = parseFloat(a[sort] || 0.0);
            let valB = parseFloat(b[sort] || 0.0);
            if (sortDirection === Sort.direction.ascending) {
                return valA - valB;
            } else {
                return valB - valA;
            }
        } else if (typeof a[sort] === "string") {
            let valA = a[sort];
            let valB = b[sort];
            valA = valA.toLowerCase();
            valB = valB.toLowerCase();

            if (sortDirection === Sort.direction.descending) {
                if (valA >= valB) {
                    return 1;
                } else {
                    return -1;
                }
            } else {
                if (valA <= valB) {
                    return 1;
                } else {
                    return -1;
                }
            }
        }
    };
}

function compareCoins(appState) {
    let sort = appState.sort;
    let sortDirection = appState.sortDirection;

    return compare(sort, sortDirection);
}


let Sort = {
    direction: {
        ascending: "asc",
        descending: "desc"
    },
    compare: compareCoins,
    compareManual: compare
};

export default Sort;



// WEBPACK FOOTER //
// ./src/Sort.js